// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1UFBj","notes":"Notes_notes__2WyAB"};